import { SearchesControllerApi } from 'generated/api/apis/SearchesControllerApi'
import { createConfiguration, createFionaClient } from 'services/FionaAPI/templates/ClientFactory'
import { checkForAlreadyExecutedSearchError } from 'services/FionaAPI/Search/errors'

//TODO: Import generated APIs dynamically
const searchClient = () => {
	const client = new SearchesControllerApi(createConfiguration())

	return {
		createSearch: createFionaClient(client.searchesControllerCreateSearch.bind(client)),
		patchSearch: createFionaClient(client.searchesControllerPatchSearch.bind(client)),
		patchSection: createFionaClient(client.searchesControllerPatchSectionWithinSearch.bind(client)),
		getAllSearches: createFionaClient(client.searchesControllerGetAllSearches.bind(client)),
		findSectionWithinSearch: createFionaClient(client.searchesControllerFindSectionWithinSearch.bind(client)),
		getMostRecent: createFionaClient(
			client.searchesControllerGetMostRecentRaw.bind(client),
			checkForAlreadyExecutedSearchError
		),
		getResults: createFionaClient(client.searchesControllerGetResults.bind(client)),
		findSectionWithinSearchRaw: createFionaClient(client.searchesControllerFindSectionWithinSearchRaw.bind(client)),
		createSearchFromExistingLead: createFionaClient(client.searchesControllerCreateSearchFromExistingLead.bind(client))
	}
}
type SearchClient = ReturnType<typeof searchClient>
let searchClientInstance: SearchClient
export const getSearchClient = (rebuild = false) => {
	if (rebuild || !searchClientInstance) {
		searchClientInstance = searchClient()
	}
	return searchClientInstance
}
